import React from 'react'
import produce from 'immer'
import Input from 'src/components/base/Input'
import { Mobru } from 'src/types'

import ProductHolderModal, { BaseProductHolder } from './ProductHolderModal'
import { getMobruErrors } from '../utils'

export type TPropsMobruModal = {
  selectedMobru: Mobru | null
  isOpen: boolean
  onMobruConfirm: (mobru: Mobru | undefined) => void
  onCancel?: () => void
}

function MobruModal({ selectedMobru, onMobruConfirm, isOpen, onCancel }: TPropsMobruModal) {
  return (
    <ProductHolderModal<Mobru & BaseProductHolder>
      selected={selectedMobru as Mobru}
      isOpen={isOpen}
      onConfirm={onMobruConfirm}
      onCancel={onCancel}
      subjectName="cargo belts"
      idPrefix="cargo-belts"
      validateEntity={getMobruErrors as (e: Mobru) => string[]}
      renderTopFields={({ entity, setEntity }) => (
        <>
          <Input
            label="Bollard start"
            id="bollard-start"
            type="number"
            value={(entity as Mobru)?.bollardStart ?? ''}
            onChange={e => {
              const newBollardStart = Number(e.target.value)
              setEntity(draft => {
                draft.bollardStart = newBollardStart
              })
            }}
            required
            parentStyle={{ flex: 1 }}
            flexibleWidth
          />
          <Input
            label="Bollard end"
            id="bollard-end"
            type="number"
            value={(entity as Mobru)?.bollardEnd ?? ''}
            onChange={e => {
              const newBollardEnd = Number(e.target.value)
              setEntity(draft => {
                draft.bollardEnd = newBollardEnd
              })
            }}
            required
            parentStyle={{ flex: 1 }}
            flexibleWidth
          />
        </>
      )}
    />
  )
}

export default MobruModal
